import { matchPath, matchRoutes } from 'react-router-dom';

import { homepageService } from '../common/services/homepage/homepageService';
import { AppRoutePatterns, appRoutes, routePathObjects } from './appRoutes';

export function getInitialEntries(history: string[]): string[] {
  const sanitizedHistory = history.filter(
    (url) => !!matchRoutes(routePathObjects, url),
  );

  if (!homepageService.homepageEnabled) {
    return sanitizedHistory.length > 0
      ? sanitizedHistory
      : [appRoutes.categories()];
  }

  // TODO: it can be removed after merge 'specs.engage.enableHomepage'
  const initialEntries = sanitizedHistory
    .map(mapOldStyleRoute)
    // remove side by side duplicate strings
    // ['/article/id/1234', '/article/id/1234', '/search?query=velo'] -> ['/article/id/1234', '/search?query=velo']
    // this case is possible after removing unsupported query params, for example we can have:
    // ['/article/id/1234?isChatbotOpen=true', ''/article/id/1234?isChatbotOpen=false']
    // and after 'mapOldStyleRoute' it will be ['/article/id/1234', '/article/id/1234'],so we need to handle this case
    .filter((route, i, arr) => route !== arr[i + 1]);

  // First item in 'initialEntries' should always be Homepage(by design).
  // Need this fix to support history from users who have just turned on the homepage(specs.engage.enableHomepage).
  // They do not have a homepage route in navigation history
  const firstEntries = initialEntries[0];
  if (!firstEntries || !matchPath(AppRoutePatterns.Home, firstEntries)) {
    initialEntries.unshift(appRoutes.home());
  }

  return initialEntries;
}

function mapOldStyleRoute(route: string): string {
  // create a URL instance to be able to use URLSearchParams and parse route correctly
  const url = new URL(route, window.location.origin);
  const supportedQueryParams = ['query'];

  // remove all unsupported query params
  url.searchParams.forEach((value, name) => {
    if (!supportedQueryParams.includes(name)) {
      url.searchParams.delete(name);
    }
  });

  return `${url.pathname}${url.search}${url.hash}`;
}
